import { MONTHLY_FEES } from "../../../Accounts/MonthlyPayments/constants/guidelineCharges";
import { findMonthlyFeeGuideline } from "../../../Accounts/MonthlyPayments/utils/monthlyFeeGuideline";

const normalise = (value) => String(value || "").trim().toLowerCase();

export const MONTHLY_FEE_OPTIONS = MONTHLY_FEES.map((fee) => ({
  id: fee.permission,
  name: `${fee.permission} | £${Number(fee.amount).toFixed(2)}`,
}));

export const monthlyFeeAmountForPermission = (permission = "") =>
  MONTHLY_FEES.find(
    (fee) =>
      normalise(fee.permission) === normalise(permission) ||
      normalise(fee.id) === normalise(permission),
  )?.amount ?? "";

export const resolveMonthlyFeePermission = ({
  savedPermission = "",
  amount = "",
  statuses = [],
} = {}) => {
  const explicitlySaved = MONTHLY_FEES.find(
    (fee) =>
      normalise(fee.permission) === normalise(savedPermission) ||
      normalise(fee.id) === normalise(savedPermission),
  );
  if (explicitlySaved) return explicitlySaved.permission;

  const guideline = findMonthlyFeeGuideline(statuses);
  if (
    guideline &&
    (amount === "" || Number(guideline.amount) === Number(amount))
  ) {
    return guideline.permission;
  }

  const amountMatches = MONTHLY_FEES.filter(
    (fee) => amount !== "" && Number(fee.amount) === Number(amount),
  );
  return amountMatches.length === 1 ? amountMatches[0].permission : "";
};
